export default __webpack_public_path__ + "31c4833db6f92e6410d31bc7d065fc54.png";